import { useMemo } from 'react';

type ConflictWindow = Window & {
  MooTools?: unknown;
  Prototype?: unknown;
};

/* Если на странице есть MooTools или Prototype, то происходит конфликт,
   не позволяющий загрузить svg иконки, используя ReactSVG */
export function useDetectConflict(): boolean {
  const conflictWindow = window as ConflictWindow;
  const { MooTools, Prototype } = conflictWindow;

  return useMemo(() => !!(MooTools || Prototype), [MooTools, Prototype]);
}
